export default __webpack_public_path__ + "static/media/filter-mobile-icon.de961e19.svg";